import { useEffect, useState } from 'react';

import type { ComponentRegistry } from '../../services/component-registry';
import { registerContainerAndContentComponents } from './register-container-content';
import { registerDataAndNavComponents } from './register-data-nav';
import { registerWidgetComponents } from './register-widget';

const bootstrappedRegistries = new WeakSet<ComponentRegistry>();

export function ensureBuiltInViewComponentsRegistered(
  registry: ComponentRegistry
): boolean {
  if (bootstrappedRegistries.has(registry)) return false;
  registerContainerAndContentComponents(registry);
  registerDataAndNavComponents(registry);
  registerWidgetComponents(registry);
  bootstrappedRegistries.add(registry);
  return true;
}

export function useEnsureBuiltInViewComponentsRegistered(
  registry: ComponentRegistry
): void {
  const [, setRegistrationRevision] = useState(0);

  useEffect(() => {
    if (ensureBuiltInViewComponentsRegistered(registry)) {
      setRegistrationRevision(revision => revision + 1);
    }
  }, [registry]);
}
